import { styled } from '@mui/system'
import { Grid } from "@mui/material";
import { LuExternalLink } from "react-icons/lu";
import AppBar from "../components/AppBar";



interface Props {
}

const SettingLegal: React.FC<Props>=({})=>{
    const Main = styled('main')(({ theme }) => ({ }));

    
    return (
        <Main id="content">
            <AppBar/>

            <section className="container">

                <ul className="ben-page-nav ben-page-nav-tabs" id="PageNavigator">
                    <li className="ben-page-nav-item">
                        <a className="ben-page-nav-link active">Profile</a>
                    </li>
                </ul>


                <div className="ben-groom-panel">
                    <div style={{paddingTop: '1.5rem'}}>


                        <ul className="setting-nav setting-nav-tabs" id="setting-setTab" role="tablist">
                            <li className="setting-nav-item">
                                <a className="setting-nav-link" href="/settings/profile"><span className="setting-user-icon"></span>Profile</a>
                            </li>
                            <li className="setting-nav-item">
                                <a className="setting-nav-link" href="/settings/account-management"><span className="setting-credit-icon"></span>Account Management</a>
                            </li>
                            <li className="setting-nav-item">
                                <a className="setting-nav-link active" href="/settings/legal"><span className="setting-smartshield"></span>Legal</a>
                            </li>
                            <li className="setting-nav-item">
                                <a className="setting-nav-link" href="/settings/help"><span className="setting-bigedit"></span>Help &amp; Support</a>
                            </li>
                        </ul>
                    </div>



                    <Grid container style={{justifyContent: 'center'}}>
                        <Grid item style={{padding: '0 15px'}} xs={12} lg={8.5}>
                            <div style={{padding: '0 1rem'}}>

                                <div style={{marginTop: '1rem'}}>
                                    <a href="/zprivacy.html" className="btn legal-external__btn--link" rel="noopener noreferrer" target="_blank">
                                        <span className="legal-btn-external__btn--link">elite community account privacy policy</span> <span><LuExternalLink /></span>
                                    </a>
                                    <a href="/zterm.html" className="btn legal-external__btn--link" rel="noopener noreferrer" target="_blank">
                                        <span className="legal-btn-external__btn--link">elite community account terms and conditions</span><span><LuExternalLink /></span>
                                    </a>
                                    <a href="/zgterm.html" className="btn legal-external__btn--link" rel="noopener noreferrer" target="_blank">
                                        <span className="legal-btn-external__btn--link">elite community savings goals terms and conditions</span><span><LuExternalLink /></span>
                                    </a>
                                </div>

                            </div>
                        </Grid>
                    </Grid>

                </div>

            </section>

        </Main>
    )
}

export default SettingLegal